import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import GridKeikkaEditor_Teksti from "src/components/grid/GridKeikkaEditor/components/GridKeikkaEditor/tabs/GridKeikkaEditor_Teksti";
import { useUserData } from "src/context/userContext";
import { keikka_getKeikka } from "src/data/keikka/KeikkaFunctions";

export default function KeikkaViewer({ keikkaId = null, onClose = () => {} }) {
  const { token } = useUserData();
  const [keikka, setKeikka] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const asynk = async () => {
      const k = await keikka_getKeikka(keikkaId, token);
      if (!k) {
        setError(true);
        return;
      }
      setKeikka(k[0]);
    };
    asynk();
  }, [keikkaId]);

  if (error) return <div>Virhe....</div>;
  if (!keikka) return <div>Ladataan...</div>;

  return <GridKeikkaEditor_Teksti keikka={keikka} onClose={onClose} />;
}

KeikkaViewer.propTypes = {
  keikkaId: PropTypes.number,
  onClose: PropTypes.func,
};
